import {
  FETCH_LUCKYDRAW_TOKEN_SUCCESS,
  FETCH_LUCKYDRAW_TOKEN_FAILURE,
} from '../actions/luckydrawActions';

const defaultState = {};

export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    case FETCH_LUCKYDRAW_TOKEN_SUCCESS:
      const { luckydrawToken } = action.payload;
      nextState.luckydrawToken = luckydrawToken;
      return nextState;
    case FETCH_LUCKYDRAW_TOKEN_FAILURE:
      nextState.authTokenFailure = action.payload;
      return nextState;
    default:
      return nextState;
  }
};
